module.exports = __webpack_public_path__ + "static/media/bunny.d8b35ba0.webp";